
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("alaek", function(module, exports) {

$parcel$export(module.exports, "default", () => $21bae01687242d76$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $esRft = parcelRequire("esRft");

var $6fnsQ = parcelRequire("6fnsQ");

var $cmDjE = parcelRequire("cmDjE");

var $aW43R = parcelRequire("aW43R");
const $21bae01687242d76$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`;
const $21bae01687242d76$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $6fnsQ.N90)})`;
function $21bae01687242d76$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
        appearance: (0, $aW43R.isSquareIcon)(src) ? 'square' : 'circle',
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cmDjE.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId
        })
    });
}

});
parcelRegister("cmDjE", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $bdf91181004cdb95$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $huXH9 = parcelRequire("huXH9");
var $3wBuN = parcelRequire("3wBuN");

var $lebfc = parcelRequire("lebfc");

var $f9sHQ = parcelRequire("f9sHQ");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");

var $5P3yi = parcelRequire("5P3yi");

var $iPlAO = parcelRequire("iPlAO");
const $bdf91181004cdb95$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`;
const $bdf91181004cdb95$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $6fnsQ.N90)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $bdf91181004cdb95$var$ICON_PADDING = 4;
const $bdf91181004cdb95$var$avatarDefaultIconStyles = (0, $3jLHL.css)({
    display: 'flex',
    backgroundColor: $bdf91181004cdb95$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $bdf91181004cdb95$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $bdf91181004cdb95$var$nestedAvatarStyles = Object.entries((0, $huXH9.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: (0, $3jLHL.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $bdf91181004cdb95$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $bdf91181004cdb95$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $bdf91181004cdb95$var$avatarImageStyles = (0, $3jLHL.css)({
    display: 'flex',
    flex: '1 1 100%',
    width: '100%',
    height: '100%'
});
const $bdf91181004cdb95$export$9cfabd93718c0a2e = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $gwFzn.useState)(false);
    // If src changes, reset state
    (0, $gwFzn.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        if ((0, $dh538.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $5P3yi.FallbackAvatar), {
            "aria-label": alt,
            width: $bdf91181004cdb95$var$SIZES[size],
            height: $bdf91181004cdb95$var$SIZES[size],
            "data-testid": testId
        });
        return /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
            css: [
                $bdf91181004cdb95$var$avatarDefaultIconStyles,
                $bdf91181004cdb95$var$nestedAvatarStyles[size]
            ]
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
            label: alt,
            color: $bdf91181004cdb95$var$ICON_BACKGROUND,
            LEGACY_secondaryColor: $bdf91181004cdb95$var$ICON_COLOR,
            testId: testId && `${testId}--team`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f9sHQ)))
        }));
    }
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, $3jLHL.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $bdf91181004cdb95$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};
const $bdf91181004cdb95$export$ac3673635a5387be = (props)=>{
    if ((0, $dh538.fg)('team-avatar-radii')) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $iPlAO.TeamAvatarImage), props);
    return /*#__PURE__*/ (0, $3jLHL.jsx)($bdf91181004cdb95$export$9cfabd93718c0a2e, props);
};

});
parcelRegister("5P3yi", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $2cfa1b514c8db58a$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
const $2cfa1b514c8db58a$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $2cfa1b514c8db58a$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $2cfa1b514c8db58a$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("iPlAO", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $b1ffb7aff4492d0d$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $7ntbu = parcelRequire("7ntbu");
const $b1ffb7aff4492d0d$var$boxShadowCssVar = '--avatar-box-shadow';
const $b1ffb7aff4492d0d$var$bgColorCssVar = '--avatar-bg-color'; /**
                                            * We need to maintan the container styles manually until Avatar provides the correct border radius.
                                            * After that we can return to wrapping in <AvatarContent> rather than span
                                            */ 
const $b1ffb7aff4492d0d$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $b1ffb7aff4492d0d$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y"
};
const $b1ffb7aff4492d0d$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $b1ffb7aff4492d0d$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $b1ffb7aff4492d0d$var$borderRadiusMap = {
    xsmall: "_2rko1y44",
    small: "_2rkoi2wt",
    medium: "_2rkoftgi",
    large: "_2rko19bv",
    xlarge: "_2rko1tcg",
    xxlarge: "_2rkozwfg"
};
const $b1ffb7aff4492d0d$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
}; /**
    * __Avatar image__
    *
    * An avatar image is an internal component used to control the rendering phases of an image.
    */ 
const $b1ffb7aff4492d0d$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $gwFzn.useState)(false); // If src changes, reset state
    (0, $gwFzn.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7ntbu.FallbackAvatar), {
        "aria-label": alt,
        width: $b1ffb7aff4492d0d$var$SIZES[size],
        height: $b1ffb7aff4492d0d$var$SIZES[size],
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $35pXk.default)([
            $b1ffb7aff4492d0d$var$unboundStyles.root,
            $b1ffb7aff4492d0d$var$containerStyles.root,
            $b1ffb7aff4492d0d$var$borderRadiusMap[size],
            $b1ffb7aff4492d0d$var$widthHeightMap[size]
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
            src: src,
            alt: alt,
            "data-testId": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $35pXk.default)([
                $b1ffb7aff4492d0d$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("7ntbu", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $03901c315b3bb158$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
const $03901c315b3bb158$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $03901c315b3bb158$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $03901c315b3bb158$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});



parcelRegister("aW43R", function(module, exports) {

$parcel$export(module.exports, "isSquareIcon", () => $69f4969c98c01397$export$d5a05ffb65695bc0);

var $dh538 = parcelRequire("dh538");
function $69f4969c98c01397$export$d5a05ffb65695bc0(src) {
    if (!src) return false;
    try {
        const url = new URL(src);
        const host = url.host;
        const path = url.pathname;
        if ((host.startsWith('ptc-directory-sited-static') || host.startsWith('teams-directory-frontend')) && path.includes('teams/avatars/v4') && (0, $dh538.fg)('enable-team-avatar-switch')) return true;
    } catch  {
    // The src wasn't a URL, so it's obviously not the refreshed avatar.
    }
    return false;
}

});



//# sourceMappingURL=PageLabelsAutomationDiscovery.34a068c7.js.map
